import { render, staticRenderFns } from "./Dashboard.page.vue?vue&type=template&id=514bdf61&scoped=true&"
import script from "./Dashboard.page.vue?vue&type=script&lang=js&"
export * from "./Dashboard.page.vue?vue&type=script&lang=js&"
import style1 from "./Dashboard.page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514bdf61",
  null
  
)

export default component.exports